import ApiConnection from "./connection";

const saveLog = async (logData) => {
  try {
    const response = await ApiConnection.post("/logviews/save-logs", logData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Erro ao salvar log");
  }
};

const updateLog = async (token, username, type) => {
  
  try {
    const response = await ApiConnection.post("/logviews/update", username, type, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Erro ao salvar log");
  }
};

export default function log() {
  return {
    saveLog,
    updateLog,
  };
}
